import React, { useEffect, useState, useRef } from 'react';

import '/src/styles/index.css';
import styles from './style.module.css';
import ScheduleMailingConstructor from './scheduleMailingConstructor/ScheduleMailingConstructor'
import Select from 'react-select';
import backIcon  from '../../../../../assets/get_back.png';

const customSelect = {
    menu: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: '#1D1C1C',
    color:'#fff', 
    textAlign: 'left',
    zIndex: '999'
    }),
    option: (baseStyles, state) => ({
    ...baseStyles,
    cursor:'pointer',
    color: state.isFocused ? '#1D1C1C' : '#fff',
    backgroundColor: state.isFocused ? '#3ED656' : '#1D1C1C',
    }),
    control: (provided, state) => ({
    ...provided,
    backgroundColor: '#1D1C1C',
    borderColor: state.isFocused ? '#3ED656' : '',
    boxShadow: state.isFocused ? '' : '',
    border: 'none',
    marginRight: '5px',
    cursor:'pointer'
    }),
    singleValue: (provided, state) => ({
    ...provided,
    color: '#fff'
    })
};

const MailingSchedule = ({ botsData, spamsSchaludeData, refreshSpamsData}) => {


    const botsOptions = botsData.map(item => ({
        value: item.id,
        label: item.bot_name
    }));
    const [selectedBot, setSelectedBot] = useState(null);
    const [scheduleData, setScheduleData] = useState(null);
    const [scheduleMailing, setScheduleMailing] = useState(false);
    const [spamsData, setSpamsData]= useState([]);

    const handleSetCurrentBot = (botId) => {
        setSelectedBot(botId);
       
        setSpamsData(spamsSchaludeData.filter(item => item.bot_id.includes(botId)));
       
        setScheduleMailing(false);
    };
    const handleSelectMailing = (id) =>{
        setSelectedBot(null);
        setScheduleMailing(true);
        setScheduleData(spamsSchaludeData.find(item => item.id === id));
        
    }

   
    
    const [returnToSchedule, setReturnToSchedule] = useState(false);

    const resetScheduleData = (reset) =>{
        if (reset) {
            setScheduleMailing(false);
            setSpamsData([]);
            setScheduleData(null);
            setReturnToSchedule(false);
        }
    }

    useEffect(() => {
        if (scheduleData) {
            setReturnToSchedule(false);
        }
    }, [scheduleData]);
    
    
        return (
            <form className="card">
                <h2 className='card-title'>
                    <p>{!scheduleData ? 'Отложенные рассылки' : 'Редактировать отложенную рассылку'}</p>
                </h2>
                <div className="form-row">
                    {!scheduleData && (
                        <> 
                            <Select
                                name="botId"
                                placeholder="Выберите бота"
                                options={botsOptions}
                                value={selectedBot ? botsOptions.find(option => option.value === selectedBot) : null}
                                onChange={(e) => {
                                    handleSetCurrentBot(e.value);
                                }}
                                styles={customSelect}
                            />
                        </>
                    )}
                    {selectedBot && spamsData && spamsData.length > 0 ? (
                        <>
                            <div className={styles['mailing-title']}>
                                Выберите рассылку из списка ниже для редактирования:
                            </div>
                            <div className='form-row'>
                                <div className={styles['schalude-mailing-item']}>  
                                    <p>Название рассылки:</p>
                                    <p>Дата отправки:</p>
                                    <p>Количество получателей:</p>
                                </div>
                                {spamsData.map(item => (
                                <div className={styles['schalude-mailing-item']} 
                                onClick={()=>handleSelectMailing(item.id)}>
                                    <p>{item.name}</p>
                                    <p>{item.time_send}</p>
                                    <p>{item.receivers}</p>
                                </div>
                                )).reverse()
                                }
                            </div>
                        </>
                    ) : (
                        <>
                            {selectedBot && spamsData.length === 0 ? (
                                <p className='form-row'>У выбраного вами бота нет отложенных рассылок !</p>
                            ):null}
                        </>
                        
                    ) }
                    {scheduleMailing && (
                        <>
                        
                            {!returnToSchedule && (
                                <a className="breadcrumbs form-row" onClick={resetScheduleData}>
                                    Вернуться к выбору рассылок
                                </a>
                            )}
                            <ScheduleMailingConstructor botsData={botsData} scheduleData={scheduleData} returnToSchedule={returnToSchedule} setResetScheduleData={resetScheduleData} refreshSpamsData={refreshSpamsData}></ScheduleMailingConstructor>
                        </>
                        
                    )
                    }
                </div>
            </form>      

        );
};

export default MailingSchedule;